"use client";
import { useState } from "react";
import posthog from "posthog-js";
import BookDemoModal from "./BookDemoModal";

interface BookAuditCallButtonProps {
  /** Visible CTA text. Defaults to the canonical primary-CTA label. */
  label?: string;
  /** When provided, fully replaces the default button classes. */
  className?: string;
  /** Optional funnel context (e.g. "home-hero", "results-closing") sent with the analytics event. */
  location?: string;
}

const DEFAULT_CLASSES =
  "inline-flex items-center justify-center px-5 py-2 bg-ink text-surface font-semibold text-[14px] rounded-lg hover:opacity-90 active:opacity-80 transition-opacity cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2";

export default function BookAuditCallButton({
  label = "Book an Audit Call",
  className,
  location,
}: BookAuditCallButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          posthog.capture("cta_book_audit_call_click", { label, location });
          setIsOpen(true);
        }}
        className={className ?? DEFAULT_CLASSES}
      >
        {label}
      </button>
      <BookDemoModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
